import Placard from './Placard';
import Filmstrip from './Filmstrip';

const GeneratorPanel = ({
            zooms,
            display,
            current,
            saved,
            saveError,
            onToggleSave,
            cw,
            ch,
            handleMouseDown,
            handleMouseRelease,
            handleMouseMove,
            handleTouchStart,
            handleTouchMove,
            handleTouchEnd,
            reloadZoom,
            manualZoom
    }) => {

    return (
        <div id="mandelbrot-wrapper">
            <div id="fractal-wrapper">
                <img
                    src={display}
                    alt="Generated Mandelbrot fractal"
                    className="fractal-display"
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseRelease}
                    onMouseMove={handleMouseMove}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                />
                <canvas
                    id="tracker"
                    width={cw}
                    height={ch}
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseRelease}
                    onMouseMove={handleMouseMove}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                ></canvas>
            </div>

            <Placard
                current={current}
                manualZoom={manualZoom}
                saved={saved}
                saveError={saveError}
                onToggleSave={onToggleSave} />
            <Filmstrip zooms={zooms} reload={reloadZoom} activeId={current.id} />
        </div>
    );
};

export default GeneratorPanel;
